import type { components } from '@front/generated/apiClient';
import { DomainV2 } from 'troppus-common/domain';

import IE = DomainV2.ImmutableEntity;
import ME = DomainV2.MutableEntity;

type ApiIE = components['schemas']['ImmutableEntity'];
type ApiME = components['schemas']['MutableEntity'];

export namespace ImmutableEntity {
  export const fromApi = (api: ApiIE): IE => {
    return IE.Construct({
      createdAt: api.createdAt,
      createdBy: api.createdBy,
    });
  };
  export const fromDomain = (domain: IE): ApiIE => {
    return {
      createdAt: domain.createdAt.toISOString(),
      createdBy: domain.createdBy,
    };
  };
}

export namespace MutableEntity {
  export const fromApi = (api: ApiME): ME => {
    return ME.Construct({
      ...ImmutableEntity.fromApi(api),
      updatedAt: api.updatedAt,
      updatedBy: api.updatedBy,
    });
  };
  export const fromDomain = (domain: ME): ApiME => {
    return {
      ...ImmutableEntity.fromDomain(domain),
      updatedAt: domain.updatedAt.toISOString(),
      updatedBy: domain.updatedBy,
    };
  };
}
